import {styled} from '@innowise-group/ui-kit';

export const DatePickerLabel = styled.label`
  position: absolute;
  top: 0;
  left: 0.25rem;
  transform: translateY(-50%);
  background: ${({theme}) => theme.palette.specials.meetings.background};
  padding: 0 0.25rem;
  color: ${({theme}) => theme.palette.specials.meetings.label};
  font-variant-numeric: lining-nums tabular-nums;
  font-feature-settings: 'cv03' on, 'cv04' on;
  font-family: Manrope;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.57;
  letter-spacing: 0.016rem;

  &::after {
    content: '*';
    color: #c63031;
    margin-left: 0.25rem;
  }

  @media (max-width: 769px) {
    font-size: 0.875rem;
  }

  @media (max-width: 480px) {
    font-size: 0.8rem;
  }
`;

export const DatePickerInput = styled.input`
  height: 100%;
  width: 100%;
  color: ${({theme}) => theme.palette.general.darkGrey[100]};
  font-variant-numeric: lining-nums tabular-nums;
  font-feature-settings: 'cv03' on, 'cv04' on;
  font-family: Manrope;
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.375;
  letter-spacing: 0.016rem;
  border: none;
  background-color: transparent;
  cursor: pointer;

  &:focus-visible {
    outline: none;
  }

  &:disabled {
    cursor: not-allowed;
  }

  &::placeholder {
    color: ${({theme}) => theme.palette.general.darkGrey[100]};
  }

  &:disabled::placeholder {
    color: ${({theme}) => theme.palette.general.darkGrey[60]};
  }

  @media (max-width: 769px) {
    font-size: 0.875rem;
  }

  @media (max-width: 480px) {
    font-size: 0.8rem;
  }
`;
